import React, { Component } from 'react';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { compose } from 'react-recompose';
import { ElasticTheme as Theme, Typography, RobotIcon } from '@dev/ee-components';

import { ErrorProps } from '../ErrorInterface';
import { ApplicationState as State } from '../../../store';

const ErrorCode = styled.h2`
    color: ${Theme.palette.grey[400]};
    font-family: Nunito;
    font-size: 16px;
    font-weight: 600;
`;

const ErrorWrapper = styled.div`
    background: #fff;
    min-height: 97vh;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
`;

const Description = styled.div`
    margin: 1.3125em 0;
`;

const styles = {};

const mapState = (state: State, ownProps: ErrorProps): ErrorProps => ({
    ...ownProps,
    browser: state.browser,
});

class E401 extends Component<ErrorProps> {
    render(): JSX.Element {
        const { browser, t } = this.props;

        const contentWidth = browser.greaterThan.md ? '43%' : '87%';
        const ContentWrapper = styled.div`
            text-align: left;
            width: ${contentWidth};
            padding: 0.875em;
        `;

        return (
            <ErrorWrapper>
                <ContentWrapper>
                    <ErrorCode>Error 401</ErrorCode>
                    <Typography variant="h1" align={'left'}>
                        {t('error401_title')}
                    </Typography>
                    <Description>{t('error401_desc')}</Description>
                </ContentWrapper>
                {browser.greaterThan.sm && <RobotIcon width={600} height={390} />}
            </ErrorWrapper>
        );
    }
}

export default compose(withStyles(styles), withTranslation(), connect<ErrorProps>(mapState))(E401);
